import { palette } from '../../theme';
import { Box } from '@mui/material';
import { memo } from 'react';

type Props = {
  checked: boolean;
  disabled: boolean;
};

/**
 * Decorative checkmark indicator. Avoids using a real checkbox in the interest
 * of assistive technology. Parent OptionItem row handles selection.
 */
export const Checkbox = memo(({ checked, disabled }: Props) => {
  return (
    <Box
      component="span"
      aria-hidden
      sx={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 24,
        height: 24,
      }}
    >
      {checked ? (
        <>
          <span
            className="mask-icon mask-icon-checkbox-blank"
            style={{ backgroundColor: palette.primary.main, width: '24px', height: '24px' }}
          />
          <span
            className="mask-icon mask-icon-check"
            style={{
              backgroundColor: palette.primary.main,
              width: '18px',
              height: '18px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          />
        </>
      ) : (
        <span
          className="mask-icon mask-icon-checkbox-blank"
          style={{
            backgroundColor: disabled ? palette.neutral.lighter : palette.neutral.light,
            width: '24px',
            height: '24px',
          }}
        />
      )}
    </Box>
  );
});
